import React, { Component } from 'react';
import PhotoCardsSwiper from "../components/PhotoCardsSwiper";
import { Link } from "react-router-dom";

const cardImages = [
  "images/Blog/cardinosanimat1.jpg",
  "images/Blog/cardinosanimat2.jpg",
  "images/Blog/cardinosanimat3.jpg",
  "images/Blog/cardinosanimat4.jpg",
  "images/Blog/cardinosanimat5.jpg",
  "images/Blog/cardinosanimat6.jpg",
  "images/Blog/cardinosanimat7.jpg",
  "images/Blog/cardinosanimat8.jpg"
];

class DinosMecatronicos extends Component {
  componentDidMount() {
  if (window.startx) {
    window.startx();
  }
}
  render() {
    return (
      <div id="main" className="wrapper style1">
        <div className="container">
          <header className="major">
            <h2>¡Llegaron nuevos dinosaurios animatrónicos al Dinoparque!</h2>
          </header>
          <div className="containerimagenblog">
            <img className="imagenBlog" src="images/Blog/dinosanimatronicosportada.jpg" alt="Dinosaurios Animatrónicos" />
          </div>
          <span className="containerblog">
            <div className="align justify">
              <p>
                El Dinoparque sigue creciendo y sorprendiendo a sus visitantes con la llegada de nuevos dinosaurios 
                animatrónicos, que hacen que la experiencia sea más realista, emocionante y divertida que nunca. 
                En esta ocasión, el parque incorpora siete dinosaurios diferentes, todos con movimiento y 
                sonidos, que transportan a niñas, niños y adultos a una auténtica aventura prehistórica.
                Esta nueva atracción busca despertar la curiosidad, la imaginación y el asombro de quienes recorren el Dinoparque.
              </p>
              <p>
                Entre los nuevos habitantes prehistóricos se encuentran especies icónicas que han fascinado a generaciones:
              </p>
              <ul> 
                <li> 
                  <strong> <span role="img" aria-label="dinosaurio cuello largo">🦕</span> Brachiosaurio </strong><br />
                   Uno de los dinosaurios más grandes y reconocibles, que destaca por su enorme tamaño y su largo cuello, ideal
                    para sorprender desde lejos a los visitantes. 
                </li> 
                <li>
                   <strong> <span role="img" aria-label="dinosaurio carnívoro">🦖</span> Tyrannosaurus rex </strong><br /> 
                   El favorito de muchos, famoso por su imponente presencia y su poderoso rugido, que sin duda se convierte en 
                   uno de los puntos más emocionantes del recorrido. 
                </li> 
                <li> 
                  <strong> <span role="img" aria-label="dinosaurio con cuernos">🦴</span> Triceratops </strong><br />
                   Reconocido por sus tres cuernos y su gran fuerza, este dinosaurio animatrónico sorprende por sus movimientos y realismo. 
                </li> 
                <li> 
                  <strong> <span role="img" aria-label="huellas de dinosaurio">🐾</span> Otros dinosaurios animatrónicos </strong><br /> 
                  El recorrido se complementa con más especies prehistóricas, cada una con características únicas, sonidos y movimientos
                   que enriquecen la experiencia y hacen del Dinoparque un espacio aún más dinámico. 
                </li> 
              </ul>
              <p>
                Estos nuevos dinosaurios animatrónicos están pensados para que las familias puedan disfrutar de una 
                experiencia envolvente, aprender de forma divertida y tomarse fotografías increíbles durante su visita. 
                La combinación de tecnología, diseño y ambientación convierte al Dinoparque en un lugar donde la historia cobra vida.
              </p>
              <p>
                <strong>¡Ven y descubre cómo el Dinoparque sigue evolucionando para sorprenderte!</strong>
              </p>
              
            </div>
             {/* GALERÍA REUTILIZABLE */}
            <div className="container">

              <h3 className='section-title'>Momentos Destacados</h3>
              <PhotoCardsSwiper images={cardImages} />
            </div>
            <div>
              <div className="containerjuego">
               <Link className="button" to="/blog">
                Regresar
              </Link>
              </div>
            </div>
          </span>
        </div>
      </div>
    );
  }
}

export default DinosMecatronicos;